import DatetimeHelper, {
  allDateTimeFormatOptions,
  dateFormatOptions,
  dateTimeFormatOptions,
  timeFormatOptions
} from "~/helpers/datetimeHelper";
import ContentElement from "~/models/contentManagement/contentElement";
import { DatetimeMode } from "~/models/datetimeMode";
import ObjectModelProperty from "~/models/objectModelProperties/objectModelProperty";
import Selected from "~/state/modules/selected";

export default class ObjectModelPropertyValue {
  static parseDate(dateString: string, contentElement: ContentElement, objectModelProperty: ObjectModelProperty): string | null {
    if (!dateString) return null
    const dateTimeFormatOption = allDateTimeFormatOptions.find(format=> format.value === contentElement.date_display_format);
    let propertyDatetimeMode;
    if (contentElement.builtinPropertyType){
      propertyDatetimeMode= DatetimeMode.Datetime
    } else if(objectModelProperty?.datetime_mode !== null && objectModelProperty?.datetime_mode !== undefined){
      propertyDatetimeMode = objectModelProperty?.datetime_mode
    }else{
      propertyDatetimeMode =objectModelProperty?.mapped_property_datetime_mode;
    }
    if (propertyDatetimeMode === DatetimeMode.Datetime) {
      const timezone = Selected.organization.get().time_zone;
      return DatetimeHelper.formatDate(
        DatetimeHelper.parseDate(dateString, timezone),
        timezone,
        dateTimeFormatOption?.parseFormat || DatetimeHelper.displayFormat( propertyDatetimeMode  ),
      );
    } else {
      return DatetimeHelper.formatDate(
        DatetimeHelper.parseDate(dateString),
        DatetimeHelper.timezone,
        dateTimeFormatOption?.parseFormat || DatetimeHelper.displayFormat( propertyDatetimeMode  ),
      );
    }
  }

  static formatOptions(dateTimeMode: DatetimeMode){
    switch(dateTimeMode){
      case DatetimeMode.Date:
       return dateFormatOptions;
      case DatetimeMode.Datetime:
        return dateTimeFormatOptions;
      case DatetimeMode.Time:
        return timeFormatOptions
    }
  }

  static parseList(optionClientIds: string[], contentElement: ContentElement, objectModelProperty: ObjectModelProperty): string | null {
    if (!optionClientIds) return null
    const value = objectModelProperty.objectModelPropertiesArray
      .filter(x =>
        optionClientIds.includes(x.client_id)
      ).map(x => {
          return x.label_title
        }
      )
    return value.length > 0 ? value.join(', ') : null
  }
}